'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdl';
var iconName = 'star-half-stroke';
var width = 576;
var height = 512;
var aliases = ["star-half-alt"];
var unicode = 'f5c0';
var svgPathData = ['M61.5 182.3l99.6 99.7 11.5 11.5-2.5 16.1-22 139.2 124.1-63.1 0-336.8-48.1 94.2-7.4 14.5-16.1 2.6-139.2 22.1z', 'M352.3 143.1l7.4 14.5 16.1 2.6 139.2 22.1-99.6 99.7-11.5 11.5 2.5 16.1 22 139.2-124.1-63.1 0-336.8 48.1 94.2zM272.2 48.9l0 336.8-124.1 63.1 22-139.2 2.5-16.1-11.5-11.5-99.6-99.7 139.2-22.1 16.1-2.6 7.4-14.5 48.1-94.2zM581.9 160.6c-5.5-.9-72.6-11.5-201.1-32-59.2-116-90-176.4-92.6-181.4-2.5 5-33.4 65.4-92.6 181.4-128.6 20.4-195.6 31.1-201.1 32 3.9 3.9 51.9 52 143.9 144.1-20.3 128.6-30.9 195.6-31.7 201.2 5-2.5 65.5-33.3 181.5-92.3 116 59 176.5 89.8 181.5 92.3-.9-5.5-11.4-72.6-31.7-201.2 92-92.1 140-140.1 143.9-144.1z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faStarHalfStroke = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;